import React from 'react';

import { TableDataHeader } from '@block-explorer/ui';
import { TableRow, useMatchMedia } from '@make-software/cspr-ui';
import { Trans, useTranslation } from 'react-i18next';
import { InfoSvgIcon } from '../../../components';
import styled from 'styled-components';

const StyledTableDataHeader = styled(TableDataHeader)(({ theme }) =>
  theme.withMedia({
    paddingRight: [0, 40, 150, 0],
  })
);

export interface HomeValidatorListHeadersProps {}

const HomeValidatorListHeaders = (props: HomeValidatorListHeadersProps) => {
  const { t } = useTranslation();

  const responsiveValidatorRowWidth = useMatchMedia(
    ['9.125', '13.75', '19.5', '9.125'],
    []
  );

  return (
    <TableRow>
      <TableDataHeader fixedWidthRem={Number(responsiveValidatorRowWidth)}>
        <Trans t={t}>Validator</Trans>
      </TableDataHeader>
      <TableDataHeader>
        <Trans t={t}>Fee</Trans>
      </TableDataHeader>
      <StyledTableDataHeader
        align="right"
        icon={<InfoSvgIcon src="assets/icons/ic-info.svg" />}
        tooltipText={t(
          'The total amount of CSPR staked on the validator, ' +
            'including both its own bid and all of the delegated amount. ' +
            'This value is used to determine the validator’s position in the slot auction.'
        )}
      >
        <Trans t={t}>Total Stake</Trans>
      </StyledTableDataHeader>
      <TableDataHeader
        icon={<InfoSvgIcon src="assets/icons/ic-info.svg" />}
        tooltipText={t(
          'The performance indicator is based on on-chain metrics, ' +
            "and conveys each validator's success at obtaining rewards through " +
            'consensus participation for itself and its delegators, as measured ' +
            'over the last 360 eras. A validator that performed perfectly the last ' +
            '360 eras, will have a 100% score.'
        )}
        fixedWidthRem={8.75}
      >
        <Trans t={t}>Performance</Trans>
      </TableDataHeader>
    </TableRow>
  );
};

export default HomeValidatorListHeaders;
